<template>
    <div id="placement-preference-form">
        <v-card>
            <v-card-title>
                <v-icon left :color="kingsGold">mdi-home-edit</v-icon>Placement Preferences
            </v-card-title>
            <v-alert v-if="alert" :color="dangerColor" class="mr-3 ml-3 mb-0" dense icon="mdi-alert-circle" text
                prominent>
                There are one or more required form fields that are empty. Please verify that all required form fields
                are filled in.
            </v-alert>
            <v-card-text>
                <v-form ref="placementPreferenceForm" v-model="valid" lazy-validation>
                    <v-container class="px-0" fluid>
                        <v-card-subtitle class="px-0">
                            <v-icon :color="kingsGold" left>mdi-account-multiple</v-icon>Cluster Placement
                            <br>
                            Residents can be placed in a unit with students who share similar interest (see Interest
                            Groups below in First Choice, Second Choice and Third Choice).
                        </v-card-subtitle>
                        <v-row>
                            <v-col cols="12">
                                <v-select v-model="applicant.clusterPlacement" hint="" :items="clusterPlacementItems"
                                    label="Cluster Placement" placeholder="Please select..." required
                                    :rules="clusterPlacementRules">
                                </v-select>
                            </v-col>
                        </v-row>
                        <v-card-subtitle v-if="applicant.clusterPlacement == 'Interested'" class="px-0">
                            <v-icon :color="kingsGold" left>mdi-format-list-numbered</v-icon>Cluster Placement
                            Preference
                            <br>
                            If you are interested in such a placement, please indicate your first, second and third
                            choices for placement clusters.
                        </v-card-subtitle>
                        <v-row v-if="applicant.clusterPlacement == 'Interested'">
                            <v-col cols="12" md="4">
                                <v-select v-model="applicant.clusterChoice01" :items="clusterChoice01Items"
                                    label="First Choice" placeholder="Please select..." required
                                    :rules="clusterChoice01Rules">
                                </v-select>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-select v-model="applicant.clusterChoice02" :items="clusterChoice02Items"
                                    label="Second Choice" placeholder="Please select..." required
                                    :rules="clusterChoice02Rules">
                                </v-select>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-select v-model="applicant.clusterChoice03" :items="clusterChoice03Items"
                                    label="Third Choice" placeholder="Please select..." required
                                    :rules="clusterChoice03Rules">
                                </v-select>
                            </v-col>
                        </v-row>
                        <v-card-subtitle v-if="applicant.clusterPlacement == 'Interested'" class="px-0">
                            <v-icon :color="kingsGold" left>mdi-format-list-numbered</v-icon>Building Preference OR
                            Cluster Placement
                            <br>
                            If we find that we can accommodate only your building preference OR your cluster placement,
                            which is most important to you?
                        </v-card-subtitle>
                        <v-row v-if="applicant.clusterPlacement == 'Interested'">
                            <v-col cols="12">
                                <v-select v-model="applicant.clusterBuildingPreference"
                                    :items="clusterBuildingPreferenceItems" label="Most Important"
                                    placeholder="Please select..." required :rules="clusterBuildingPreferenceRules">
                                </v-select>
                            </v-col>
                        </v-row>
                        <v-card-subtitle class="px-0">
                            <v-icon :color="kingsGold" left>mdi-head-heart</v-icon>Lifestyle (Please check all that
                            apply)
                        </v-card-subtitle>
                        <v-row>
                            <v-col cols="12">
                                <v-checkbox v-model="applicant.lifestyle" dense hide-details
                                    label="I expect to get up before 9AM on weekdays" multiple
                                    value="I expect to get up before 9AM on weekdays">
                                </v-checkbox>
                                <v-checkbox v-model="applicant.lifestyle" dense hide-details
                                    label="I usually stay up past midnight" multiple
                                    value="I usually stay up past midnight">
                                </v-checkbox>
                                <v-checkbox v-model="applicant.lifestyle" dense hide-details
                                    label="Any kind of noise distracts me while im studying" multiple
                                    value="Any kind of noise distracts me while im studying">
                                </v-checkbox>
                                <v-checkbox v-model="applicant.lifestyle" dense hide-details
                                    label="I like to study with background noise"
                                    value="I like to study with background noise">
                                </v-checkbox>
                                <v-checkbox v-model="applicant.lifestyle" dense hide-details
                                    label="I want my room to be a gathering place for friends" multiple
                                    value="I want my room to be a gathering place for friends">
                                </v-checkbox>
                                <v-checkbox v-model="applicant.lifestyle" dense hide-details
                                    label="I prefer not to have many visitors in my room" multiple
                                    value="I prefer not to have many visitors in my room">
                                </v-checkbox>
                                <v-checkbox v-model="applicant.lifestyle" dense hide-details
                                    label="I plan to maintain a fitness program" multiple
                                    value="I plan to maintain a fitness program">
                                </v-checkbox>
                                <v-checkbox v-model="applicant.lifestyle" dense hide-details
                                    label="I plan to tryout for a visitor sports team" multiple
                                    value="I plan to tryout for a visitor sports team">
                                </v-checkbox>
                                <v-checkbox v-model="applicant.lifestyle" dense hide-details
                                    label="I have toured/visited the residences at King's Unversity College" multiple
                                    value="I have toured/visited the residences at King's Unversity College">
                                </v-checkbox>
                                <v-checkbox v-model="applicant.lifestyle" dense hide-details
                                    label="I would like to be involved in the Residence Council or King's University College Student Council"
                                    multiple
                                    value="I would like to be involved in the Residence Council or King's University College Student Council">
                                </v-checkbox>
                                <v-checkbox v-model="applicant.lifestyle" dense hide-details
                                    label="I am a smoker (Please be advised that smoking is NOT permitted in any residence building)"
                                    multiple value="I am a smoker">
                                </v-checkbox>
                            </v-col>
                        </v-row>
                        <v-card-subtitle class="px-0">
                            <v-icon :color="kingsGold" left>mdi-bed</v-icon>My room is
                        </v-card-subtitle>
                        <v-row>
                            <v-col cols="12">
                                <v-radio-group v-model="applicant.lifestyleMyRoomIs" required
                                    :rules="lifestyleMyRoomIsRules">
                                    <v-radio v-for="(item, index) in lifestyleMyRoomIsItems" :key="index"
                                        :label="item.text" :value="item.value"></v-radio>
                                </v-radio-group>
                            </v-col>
                            <v-col cols="12">
                                <v-textarea v-model="applicant.applicantInterests" auto-grow counter="512"
                                    label="My Personal Interests" placeholder="Please provide any hobbies or interests"
                                    :rules="applicantInterestsRules" outlined>
                                </v-textarea>
                            </v-col>
                        </v-row>
                        <v-card-subtitle class="px-0">
                            <v-icon :color="kingsGold" left>mdi-human-greeting</v-icon>Tour Room
                            <br>
                            Residents have the opportunity to apply to be a tour room for prospective students and be
                            paid an honorarium for this role. As a tour room, your role will be to show your room to
                            students who are touring King's residence as they consider applying' to King's, and act as a
                            King's ambassador. If you are interested in this role, please indicate this by selecting
                            <b>YES</b> below.
                        </v-card-subtitle>
                        <v-row>
                            <v-col cols="12">
                                <v-radio-group v-model="applicant.tourRoom" required :rules="tourRoomRules">
                                    <v-radio v-for="(item, index) in tourRoomItems" :key="index" :label="item.text"
                                        :value="item.value"></v-radio>
                                </v-radio-group>
                            </v-col>
                        </v-row>
                        <!-- <v-card-subtitle v-if="!photoData.image" class="px-0">
                            <v-icon :color="kingsGold" left>mdi-upload</v-icon>Upload Photo - Your photo must be a passport style/portrait (head and shoulders) of <b>only yourself</b>, and in <b>JPEG</b> format.
                            <br><br>
                            <div class="font-weight-bold">Privacy Statement</div>
                            King's endeavours to protect the personal information of its students. King's only collects
                            information (including a photo) that is required for its programs and activites of its
                            students. For more information, please contact our Privacy Officer
                            at <a href="mailto:privacy@kings.uwo.ca">Privacy@kings.uwo.ca</a>.
                            <br><br>
                            <div class="font-weight-bold">Photo Guidelines</div>
                            Read the <a
                                href="https://www.kings.uwo.ca/future-students/admissions/application-process/photo-uploader-instructions/"
                                target="_blank">detailed instructions</a> on how to use the Photo Upload Service.
                            <br>
                            <ul>
                                <li>
                                    The photo must be a portrait photograph.
                                </li>
                                <li>
                                    The photo file cannot exceed <b>5 Megabytes</b> in size. Files larger than this
                                    limitation will not upload.
                                </li>
                                <li>
                                    The photo file must be in <b>JPEG</b> format.
                                </li>
                            </ul>
                        </v-card-subtitle>
                        <v-row v-if="!photoData.image">
                            <v-col class="pb-0" cols="12">
                                <v-text-field v-model="photoUpload" :color="getPhotoUploadColor"
                                    label="Photo Upload Status" placeholder="A photo has not been uploaded"
                                    :prepend-icon="getPhotoUploadIcon" readonly required :rules="photoUploadRules">
                                </v-text-field>
                            </v-col>
                            <v-col class="text-right" cols="12">
                                <v-btn class="white--text" :color="photoUploadStatus ? successColor : infoColor"
                                    @click="openPhotoUploadDialog()">
                                    <span v-if="photoUploadStatus">
                                        <v-icon left>mdi-image</v-icon>View Photo
                                    </span>
                                    <span v-else>
                                        <v-icon left>mdi-cloud-upload</v-icon>Upload Photo
                                    </span>
                                </v-btn>
                            </v-col>
                            <v-dialog v-model="photoUploadDialog" width="576">
                                <v-card>
                                    <v-card-title v-if="photoUploadStatus">
                                        View Photo
                                    </v-card-title>
                                    <v-card-title v-else>
                                        Upload Photo
                                    </v-card-title>
                                    <v-card-text>
                                        <v-alert icon="mdi-information" prominent text type="info">
                                            Please ensure your selected photo satisfy the photo
                                            guidelines and requirements as only <b>ONE</b> photo can be uploaded.
                                        </v-alert>
                                        <v-row>
                                            <v-col cols="12" class="text-center">
                                                <v-avatar v-if="!photoUploadSelect" class="profile"
                                                    :color="secondaryColor" size="256" tile>
                                                    <v-icon class="mx-auto my-auto" :color="infoColor" size="64">
                                                        mdi-image-plus</v-icon>
                                                </v-avatar>
                                                <v-avatar v-else class="profile" size="256" tile>
                                                    <v-img ref="previewImage" src=""></v-img>
                                                </v-avatar>
                                            </v-col>
                                            <v-col v-if="!photoUploadStatus" cols="12">
                                                <v-form ref="photoUploadForm" v-model="validPhotoUpload"
                                                    lazy-validation>
                                                    <v-file-input v-model="photoUploadSelect" accept="image/jpeg"
                                                        clearable="false" :color="successColor"
                                                        hint="The photo must be: a portrait photograph, in JPEG format and cannot exceed 5 Megabytes in size."
                                                        label="Upload A Photo" persistent-hint
                                                        :rules="photoUploadSelectRules" show-size
                                                        @change="setPreviewImage" type="file">
                                                    </v-file-input>
                                                </v-form>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn ref="uploadBtn" v-if="!photoUploadStatus" class="white--text"
                                            :color="successColor" @click="uploadPhoto" :disabled="!validPhotoUpload">
                                            Upload
                                        </v-btn>
                                        <v-btn :color="warningColor" @click="closePhotoUploadDialog">Cancel</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-row> -->
                    </v-container>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer>
                </v-spacer>
                <v-btn class="white--text" :color="successColor" :disabled="!valid" @click="nextStep(6)">
                    Next
                </v-btn>
                <v-btn class="white--text" :color="kingsGrey" @click="prevStep(4)">
                    Previous
                </v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>
export default {
    name: 'placement-preference-form',
    props: {
        applicant: {
            required: true
        },
        photoData: {
            required: true,
            type: Object
        }
    },
    data() {
        return {
            alert: false,
            applicantInterestsRules: [
                v => !!v || 'Personal interests is required',
                v => (v && v.length <= 512) || 'Personal interests must be between 1 and 512 characters',
            ],
            clusterBuildingPreferenceItems: [{
                    text: 'Being placed in my first building preference',
                    value: 'Building'
                },
                {
                    text: 'Being placed in the cluster group of my choice (1st or 2nd choice)',
                    value: 'Cluster'
                }
            ],
            clusterBuildingPreferenceRules: [
                v => !!v || 'Building or cluster preference is required'
            ],
            clusterChoiceItems: [{
                    text: 'Academic Success',
                    value: 'Academic Success'
                },
                {
                    text: 'Arts (theatre, music, writing. etc.)',
                    value: 'Arts'
                },
                {
                    text: 'Business and BMOS',
                    value: 'Business and BMOS'
                },
                {
                    text: 'Catholic Youth',
                    value: 'Catholic Youth'
                },
                {
                    text: 'Childhood and Social Institutions Program',
                    value: 'Childhood and Social Institutions Program'
                },
                {
                    text: 'Healthy Lifestyles',
                    value: 'Healthy Lifestyles'
                },
                {
                    text: 'International Experience',
                    value: 'International Experience'
                },
                {
                    text: 'Leadership',
                    value: 'Leadership'
                },
                {
                    text: 'Social Justice and Peace',
                    value: 'Social Justice and Peace'
                }
            ],
            clusterChoice01Rules: [
                v => !!v || 'First choice is required'
            ],
            clusterChoice02Rules: [
                v => !!v || 'Second choice is required'
            ],
            clusterChoice03Rules: [
                v => !!v || 'Third choice is required'
            ],
            clusterPlacementItems: [{
                    text: 'I am interested in a cluster placement',
                    value: 'Interested'
                },
                {
                    text: 'I am NOT interested in a cluster placement',
                    value: 'Not interested'
                }
            ],
            clusterPlacementRules: [
                v => !!v || 'Cluster placement is required'
            ],
            lifestyleMyRoomIsItems: [{
                    text: 'Very neat',
                    value: '1'
                },
                {
                    text: '2',
                    value: '2'
                },
                {
                    text: '3',
                    value: '3'
                },
                {
                    text: '4',
                    value: '4'
                },
                {
                    text: '5',
                    value: '5'
                },
                {
                    text: '6',
                    value: '6'
                },
                {
                    text: '7',
                    value: '7'
                },
                {
                    text: '8',
                    value: '8'
                },
                {
                    text: '9',
                    value: '9'
                },
                {
                    text: 'Very messy',
                    value: '10'
                }
            ],
            lifestyleMyRoomIsRules: [
                v => !!v || 'Room neatness is required'
            ],
            photoUpload: '',
            photoUploadDialog: false,
            photoUploadRules: [
                v => !!v || 'A valid photo must be uploaded'
            ],
            photoUploadSelect: '',
            photoUploadSelectRules: [
                v => (!v && v.size > 0) || v.size < 5000000 || 'Please select a valid photo within the specified requirements'
            ],
            photoUploadStatus: false,
            tourRoomItems: [{
                    text: 'YES, I am interested in this role',
                    value: 'Yes'
                },
                {
                    text: 'NO, I am not interested in this role',
                    value: 'No'
                }
            ],
            tourRoomRules: [
                v => !!v || 'Tour room is required'
            ],
            valid: true,
            validPhotoUpload: true
        }
    },
    methods: {
        closePhotoUploadDialog() {
            this.photoUploadDialog = false;
        },
        openPhotoUploadDialog() {
            this.photoUploadDialog = true;
            this.setPreviewImage();
        },
        nextStep(val) {
            if (this.$refs.placementPreferenceForm.validate()) {
                this.alert = false;
                this.$emit('setStep', val);
                this.$nextTick(() => {
                    this.$emit('scrollToTop');
                })
            } else {
                this.alert = true;
                this.$emit('scrollToTop');
            }
        },
        prevStep(val) {
            this.$emit('setStep', val);
            this.$nextTick(() => {
                this.$emit('scrollToTop');
            })
        },
        setPreviewImage() {
            const that = this;
            const reader = new FileReader();

            // Event listener
            reader.addEventListener("load", function () {
                /* eslint-disable-next-line */
                that.$refs.previewImage.src = reader.result;
            }, false);

            // Read file
            if (this.photoUploadSelect) {
                reader.readAsDataURL(this.photoUploadSelect);
            }
        },
        uploadPhoto() {
            if (this.$refs.photoUploadForm.validate()) {
                const that = this;
                const formData = new FormData();
                let api = `https://${location.hostname}/cgi-bin/snapshot-api/api.pl`;

                // Parse array into string
                formData.append('mode', 'upload');
                formData.append('formParamNameImage', 'image');
                formData.append('image', this.photoUploadSelect);
                formData.append('origin', 'res-app');

                // Loading icon
                this.$refs.uploadBtn.loading = true;

                // Post request
                fetch(api, {
                        method: 'POST',
                        body: formData
                    })
                    .then(function (response) {
                        // Return JSON response
                        return response.json();
                    })
                    .then(function (json) {
                        that.$refs.uploadBtn.loading = false;

                        // Error handling
                        if (json.result.match(/OK/i)) {
                            that.$emit('setNotification', '#1dc9b7', 'mdi-check-circle', `Your photo has been successfully uploaded.`, true);
                            that.photoUpload = "Success";
                            that.photoUploadStatus = true;
                            that.closePhotoUploadDialog();
                        } else {
                            that.$emit('setNotification', '#ffb822', 'mdi-alert-circle', `Your photo could not be uploaded. ${json.message}`, true);
                            that.photoUpload = '';
                        }
                    })
                    .catch(function () {
                        that.$refs.uploadBtn.loading = false;
                        that.$emit('setNotification', '#f64e60', 'mdi-alert-outline', `An error occurred. Please contact your system administrator.`, true);
                        that.photoUpload = '';
                    });
            }
        }
    },
    computed: {
        clusterChoice01Items() {
            return this.clusterChoiceItems;
        },
        clusterChoice02Items() {
            let secondChoiceItems = [];

            for (let i = 0; i < this.clusterChoiceItems.length; i++) {
                if (!(this.clusterChoiceItems[i].value == this.applicant.clusterChoice01)) {
                    secondChoiceItems.push(this.clusterChoiceItems[i]);
                }
            }

            return secondChoiceItems;
        },
        clusterChoice03Items() {
            let thirdChoiceItems = [];

            for (let i = 0; i < this.clusterChoiceItems.length; i++) {
                if (!(this.clusterChoiceItems[i].value == this.applicant.clusterChoice01) && !(this.clusterChoiceItems[i].value == this.applicant.clusterChoice02)) {
                    thirdChoiceItems.push(this.clusterChoiceItems[i]);
                }
            }

            return thirdChoiceItems;
        },
        dangerColor() {
            return '#f64e60';
        },
        getPhotoUploadColor() {
            if (this.photoUpload == "Success") {
                return '#1bc5bd';
            }

            return '#f64e60';
        },
        getPhotoUploadIcon() {
            if (this.photoUpload == "Success") {
                return 'mdi-check';
            }

            return 'mdi-alert';
        },
        infoColor() {
            return '#5578eb';
        },
        kingsGold() {
            return '#d7ae28';
        },
        kingsGrey() {
            return '#6d6e71';
        },
        secondaryColor() {
            return '#f9f9fc';
        },
        successColor() {
            return '#1bc5bd';
        },
        warningColor() {
            return '#ffb822'
        }
    }
}
</script>

<style scoped>
.v-input--checkbox,
.v-input--radio-group {
    margin-top: 0;
}
</style>